import { Component, OnInit, ElementRef, ViewChild, inject, PLATFORM_ID, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { gsap, Expo } from 'gsap';
import { PromoService } from '../../services/promo/promo.service';

@Component({
    selector: 'app-promo-overlay',
    standalone: true,
    imports: [],
    templateUrl: './promo-overlay.component.html',
    styleUrls: ['./promo-overlay.component.scss']
})
export class PromoOverlayComponent implements OnInit {
    @ViewChild('btnClose', { static: true }) btnClose?: ElementRef;
    @Input('isMobile')  isMobile: boolean = false

    promoService = inject(PromoService);
    private platformId = inject(PLATFORM_ID);

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            this.promoService.isPromoOpen$.subscribe((isOpen) => {
                isOpen ? this.animateIn() : this.animateOut();
            });
        }
    }

    ngOnInit(): void {}

    animateIn() {
        gsap.to('app-promo-overlay', { duration: 0.5, display: 'block', autoAlpha: 1 });
        gsap.fromTo('app-promo-overlay .wrapper', { autoAlpha: 0, x:'-50%', y:'-50%', scale: 0.8 }, { duration: 0.5, autoAlpha: 1, scale: 1, delay: 0.1, x:'-50%', y:'-50%',  ease: Expo.easeOut });
        gsap.fromTo('app-promo-overlay .content', { autoAlpha: 0, y: 15 }, { duration: 0.5, autoAlpha: 1, y: 0, delay: 0.25, ease: Expo.easeOut });
        gsap.fromTo('app-promo-overlay .closeButton', { scale: 0 }, { duration: 0.5, scale: 1, delay: 0.3, ease: Expo.easeOut });
    }

    animateOut() {
        gsap.to('app-promo-overlay', { duration: 0.4, display: 'none', autoAlpha: 0, delay: 0.05, overwrite: true });
        gsap.to('app-promo-overlay .wrapper', { duration: 0.3, scale: 0.9, autoAlpha: 0, overwrite: true, x:'-50%', y:'-50%', ease: Expo.easeOut });
    }

    onCloseOver() {
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImgOver'), { duration: 0.3, opacity: 1 });
    }

    onCloseOut() {
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImgOver'), { duration: 0.3, opacity: 0 });
    }

    onCloseClick() {
        this.promoService.closePromo();
    }
}
